import { Children, cloneElement, useState } from 'react'
import PropTypes from 'prop-types'

import { PromotionBox } from '@h2/components/containers/promotionBox'
import { Modal } from '@h2/components/containers/modal'
import { SLB90T } from '@h2/components/colors'

import { PromotionButton } from './promotionButton'
import { PromotionText } from './promotionText'
import { PromotionHeading } from './promotionHeading'
import { PromotionImage } from './promotionImage'
import { PromotionPreHeading } from './promotionPreHeading'

const Promotion = ({
  children,
  color,
  variant = 'navigator',
  modalBody = null,
  modalHeader = null,
  ...rest
}) => {
  const hasModal = modalHeader || modalBody
  const [openModal, setOpenModal] = useState(false)

  return (
    <PromotionBox
      width="100%"
      color={color}
      bgColor={variant === 'promotion' ? SLB90T : 'transparent'}
      padding={variant === 'continue' ? '30px' : '15px'}
      {...rest}>
      {Children.map(children, child => {
        if (child.type.displayName === 'PromotionButton') {
          return cloneElement(child, { color, hasModal, setOpenModal })
        }

        if (child.type.displayName === 'PromotionPreHeading') {
          return cloneElement(child, { color })
        }

        return cloneElement(child, { variant })
      })}
      {hasModal && (
        <Modal
          isOpen={openModal}
          closeOnClickOverlay={true}
          onClose={() => setOpenModal(false)}>
          <Modal.Header>{modalHeader || ''}</Modal.Header>
          <Modal.Body>{modalBody || ''}</Modal.Body>
        </Modal>
      )}
    </PromotionBox>
  )
}

Promotion.propTypes = {
  /** Which style variant to use. */
  variant: PropTypes.oneOf(['navigator', 'explorer', 'continue']).isRequired,
  color: PropTypes.oneOf(['red', 'blue', 'orange', 'green']).isRequired,
  modalBody: PropTypes.element,
  modalHeader: PropTypes.element
}

PromotionPreHeading.displayName = 'PromotionPreHeading'
PromotionHeading.displayName = 'PromotionHeading'
PromotionText.displayName = 'PromotionText'
PromotionButton.displayName = 'PromotionButton'
PromotionImage.displayName = 'PromotionImage'

Promotion.PreHeading = PromotionPreHeading
Promotion.Heading = PromotionHeading
Promotion.Text = PromotionText
Promotion.Button = PromotionButton
Promotion.Image = PromotionImage

export { Promotion }
